import { render, staticRenderFns } from "./InvestCoin.vue?vue&type=template&id=a046aa48&"
import script from "./InvestCoin.vue?vue&type=script&lang=ts&"
export * from "./InvestCoin.vue?vue&type=script&lang=ts&"
import style0 from "./InvestCoin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports